export interface FoundationActivityLogsInput {
  companyId: string;
  foundationId: string;
}
